module.exports = __webpack_public_path__ + "img/project_17.7ed94995.jpg";